module.exports = __webpack_public_path__ + "img/randabstand-EC2-draufsicht.76d16f54.png";